export default __webpack_public_path__ + "static/media/Selerant.877f96bb.png";